/**
 * De winkelwagen-URL mét taalprefix. Op /en/ en /fr/ is dat /en/cart en /fr/cart.
 * theme.liquid vult window.routes; de terugval is er voor als dat blok ooit
 * later laadt. Hardgecodeerd '/cart' gooide de bezoeker terug naar het
 * Nederlands, ook als hij van een /en/-productpagina kwam.
 */
function nlfCartUrl() {
  return (window.routes && window.routes.cart_url) || '/cart';
}

/* ============================================================
   NeverLeafs Cart, AJAX interactions
   ============================================================ */
(function () {
  'use strict';

  var page = document.querySelector('.nlc-page');
  if (!page) return;

  var THRESHOLD = 0; // verzending is altijd gratis binnen NL en BE

  /* --- Helpers --- */
  function money(cents) {
    var eur = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + eur;
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts))
      .then(function (r) { return r.json(); });
  }

  /* --- Update cart item qty --- */
  function updateItem(key, qty) {
    var item = page.querySelector('.nlc-item[data-key="' + key + '"]');
    if (item) item.classList.add('nlc-item--loading');

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: 'neverleafs_cart', sections_url: '/cart' })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || cart.item_count === 0) { window.location.reload(); return; }
      var html = cart.sections && cart.sections['neverleafs_cart'];
      if (!html) { window.location.reload(); return; }
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.nlc-page');
      if (fresh) { page.innerHTML = fresh.innerHTML; } else { window.location.reload(); }
    }).catch(function () {
      window.location.reload();
    });
  }

  /* --- Add cross-sell product --- */
  function addCrossSell(variantId, btn) {
    btn.disabled = true;
    btn.textContent = 'Toevoegen...';

    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function () {
      window.location.reload();
    }).catch(function () {
      window.location.reload();
    });
  }

  /* --- Apply promo code --- */
  function applyPromo() {
    var input = page.querySelector('.nlc-promo__input');
    if (!input) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + nlfCartUrl();
  }

  /* --- Refresh entire cart UI from cart JSON --- */
  function refreshCartUI(cart) {
    // Empty cart → reload to show empty state
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    // Update header cart count badge (common Shopify patterns)
    var badges = document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count');
    badges.forEach(function (el) { el.textContent = cart.item_count; });

    // Build lookup of items by key
    var cartItems = {};
    cart.items.forEach(function (ci) { cartItems[ci.key] = ci; });

    // Update each item card
    var itemEls = page.querySelectorAll('.nlc-item');
    itemEls.forEach(function (el) {
      var key = el.getAttribute('data-key');
      var ci = cartItems[key];
      if (!ci) {
        el.remove();
        return;
      }
      var qtyVal = el.querySelector('.nlc-qty__val');
      if (qtyVal) qtyVal.textContent = ci.quantity;

      var priceEl = el.querySelector('.nlc-item__price');
      if (priceEl) priceEl.textContent = money(ci.final_line_price);

      var unitEl = el.querySelector('.nlc-item__unit-price');
      if (unitEl) {
        if (ci.quantity > 1) {
          unitEl.textContent = money(ci.final_price) + ' per stuk';
          unitEl.style.display = '';
        } else {
          unitEl.style.display = 'none';
        }
      }

      var minusBtn = el.querySelector('[data-action="qty-minus"]');
      if (minusBtn) minusBtn.disabled = ci.quantity <= 1;

      el.classList.remove('nlc-item--loading');
    });

    // Update page count
    var countEl = page.querySelector('.nlc-page__count');
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' product' : ' producten');

    // Update shipping bar
    updateShippingBar(cart.total_price);

    // Update bundle hint
    updateBundleHint(cart.item_count);

    // Update summary
    var subtotalVal = page.querySelector('[data-summary="subtotal"]');
    if (subtotalVal) subtotalVal.textContent = money(cart.total_price);

    var subtotalLabel = page.querySelector('[data-summary="subtotal-label"]');
    if (subtotalLabel) subtotalLabel.textContent = 'Subtotaal';

    var shippingVal = page.querySelector('[data-summary="shipping"]');
    if (shippingVal) {
      if (cart.total_price >= THRESHOLD) {
        shippingVal.textContent = 'Gratis';
        shippingVal.className = 'nlc-row__val nlc-row__val--free';
      } else {
        shippingVal.textContent = 'Bij afrekenen';
        shippingVal.className = 'nlc-row__val';
      }
      shippingVal.style.color = '';
    }

    var freeHint = page.querySelector('[data-summary="freehint"]');
    if (freeHint) {
      if (cart.total_price >= THRESHOLD) {
        freeHint.style.display = 'none';
      } else {
        freeHint.style.display = '';
        var freeAmt = freeHint.querySelector('[data-summary="freehint-amount"]');
        if (freeAmt) freeAmt.textContent = money(THRESHOLD - cart.total_price);
      }
    }

    var totalEl = page.querySelector('[data-summary="total"]');
    if (totalEl) {
      totalEl.textContent = money(cart.total_price);
    }
  }

  /* --- Shipping bar update --- */
  function updateShippingBar(totalCents) {
    var bar = page.querySelector('.nlc-shipping');
    if (!bar) return;
    var fill = bar.querySelector('.nlc-shipping__fill');
    var text = bar.querySelector('.nlc-shipping__text');
    if (!fill || !text) return;

    fill.style.width = '100%';
    text.innerHTML = '<strong>Voor 16:00 besteld</strong>, morgen in huis.';
    bar.classList.add('nlc-shipping--done');
  }

  /* --- Bundle hint update --- */
  function updateBundleHint(count) {
    var hint = page.querySelector('.nlc-bundle');
    if (!hint) return;
    var textEl = hint.querySelector('.nlc-bundle__text');
    if (!textEl) return;

    // Teksten en link komen uit window.NLF_T, dat door de sectie in de juiste taal gevuld wordt.
    var T = (window.NLF_T || {});
    var link = ' <a href="' + (T.bundelUrl || '/collections/bundelvoordeel') + '">' + (T.bekijk || 'Bekijk bundels') + '</a>';
    if (count === 1) {
      textEl.innerHTML = (T.een || 'Voeg nog 1 plant toe en ontvang <strong>5% bundelkorting</strong>!') + link;
    } else if (count >= 2 && count <= 3) {
      textEl.innerHTML = (T.vijf || 'Je hebt <strong>5% korting</strong>! Voeg nog %n% toe voor <strong>10%</strong>.').replace('%n%', 4 - count) + link;
    } else if (count >= 4 && count <= 7) {
      textEl.innerHTML = (T.tien || 'Je hebt <strong>10% korting</strong>! Voeg nog %n% toe voor <strong>15%</strong>.').replace('%n%', 8 - count) + link;
    } else if (count >= 8) {
      textEl.innerHTML = (T.max || 'Je hebt de maximale <strong>15% bundelkorting</strong>!') + link;
    }
  }

  /* --- Event delegation --- */
  page.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-action');
    var item = btn.closest('.nlc-item');

    switch (action) {
      case 'qty-minus': {
        if (!item) break;
        var key = item.getAttribute('data-key');
        var val = parseInt(item.querySelector('.nlc-qty__val').textContent, 10);
        if (val > 1) updateItem(key, val - 1);
        break;
      }
      case 'qty-plus': {
        if (!item) break;
        var key2 = item.getAttribute('data-key');
        var val2 = parseInt(item.querySelector('.nlc-qty__val').textContent, 10);
        updateItem(key2, val2 + 1);
        break;
      }
      case 'remove': {
        if (!item) break;
        var key3 = item.getAttribute('data-key');
        updateItem(key3, 0);
        break;
      }
      case 'add-crosssell': {
        var variantId = btn.getAttribute('data-variant-id');
        if (variantId) addCrossSell(variantId, btn);
        break;
      }
      case 'apply-promo': {
        applyPromo();
        break;
      }
      case 'fill-promo': {
        var code = btn.getAttribute('data-code');
        var input = page.querySelector('.nlc-promo__input');
        if (input && code) {
          input.value = code;
          input.focus();
          input.classList.add('nlc-promo__input--filled');
          setTimeout(function () { input.classList.remove('nlc-promo__input--filled'); }, 600);
        }
        break;
      }
    }
  });

  // Enter key on promo input
  var promoInput = page.querySelector('.nlc-promo__input');
  if (promoInput) {
    promoInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); applyPromo(); }
    });
  }

})();
